// src/hooks/ghlSenderCreateOpportunity.ts
// Fire-and-forget helper: after a successful inbound-webhook send, calls the server-side
// create-opportunity endpoint to create a GHL opportunity via the REST API.
import type { ExtractedLeadV2 } from "@/types/lead";

export function fireCreateGhlOpportunity(params: {
  orgId: string;
  accessToken: string;
  extracted: ExtractedLeadV2;
  resolvedPipelineId: string | null;
}): void {
  const { orgId, accessToken, extracted: ex, resolvedPipelineId } = params;
  fetch("/api/ghl/action?op=create-opportunity", {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
    body: JSON.stringify({
      orgId,
      firstName: ex.first_name ?? null,
      lastName: ex.last_name ?? null,
      phone: ex.phone ?? null,
      email: ex.email ?? null,
      productLine: ex.product_line ?? null,
      sizeConfig: ex.size_config ?? null,
      resolvedPipelineId,
    }),
  }).catch((e: unknown) => console.warn("[sender] create-opportunity error", e));
}
